import { Zap } from 'lucide-react';
import { formatNumber } from '@/utils/formatNumber';
import EnergyPowerChart from '@/components/Common/energy-power-chart';
import dayjs from 'dayjs';
import { IconTitle } from '@/components/ui/icon-title';

interface ConsumptionCardProps {
  powerUsage: {
    current: number;
    avgToday: number;
  };
  energyConsumption: {
    current: number;
  };
}

const defaultData: ConsumptionCardProps = {
  powerUsage: {
    current: 343.6,
    avgToday: 351.8,
  },
  energyConsumption: {
    current: 3213.8,
  },
};


export function ConsumptionCard({
  powerUsage = defaultData.powerUsage,
  energyConsumption = defaultData.energyConsumption,
}: ConsumptionCardProps) {

  return (
    <div className="flex gap-2 p-2 bg-white rounded-[10px] shadow-card border border-light-grey h-full">
      <div className="w-[160px] flex flex-col gap-[8px]">
        {/* Title */}
        <IconTitle 
          icon={Zap} 
          title="Consumption"
        />
        
        {/* Power Usage */}
        <div className="flex flex-col justify-between h-full pt-[6px] pb-[6px] pl-[8px] pr-[8px] bg-bg border border-light-grey rounded-[8px]">
          <div className="paragraph-11 text-dark">Power Consumption</div>
          <div className="flex items-baseline gap-1">
            <span className="heading-6">{formatNumber(powerUsage.current)}</span>
            <span className="paragraph-12">kW</span>
          </div>
          <div className="flex items-center gap-1">
            <span className="paragraph-9 text-dark-grey">Today Avg.</span>
            <span className="paragraph-9 text-gray-500">{formatNumber(powerUsage.avgToday)} kW</span>
          </div>
        </div>

        {/* Energy Consumption */}
        <div className="flex flex-col justify-between h-full pt-[6px] pb-[6px] pl-[8px] pr-[8px] bg-bg border border-light-grey rounded-[8px]">
          <div className="paragraph-11 text-dark">Energy Consumption</div>
          <div className="flex items-baseline gap-1">
            <span className="heading-6">{formatNumber(energyConsumption.current)}</span>
            <span className="paragraph-12">kWh</span>
          </div>
          <div className="paragraph-9 text-dark-grey">Today</div>
        </div>
      </div>

      {/* Right Column - Chart */}
      <div className="flex-1">
        <EnergyPowerChart selectedDate={dayjs()} />
      </div>
    </div>
  );
}